const border = {
    small: "1px",
    large: "3px",
};

export default border;
